import { Grid, keyframes } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import FigmaTable from '../../../../Components/FigmaTable/FigmaTable'
import { WebSocketContext } from '../../../../Providers/WebSocket/WebSocketContext'
import { CondominiosContext } from '../../../../Providers/CondominiosContext/CondominiosContext'

import ListaEntradas from '../../../../Components/ListaEntradas/ListaEntradas'
import { showNotify } from '../../../../Utils/Utils'
import InfoSharpIcon from '@mui/icons-material/InfoSharp'
import { Ellipsis, PaiEllipsis } from '../../../MonitoramentoPage/CardEvento/SxCardEventos'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import PessoalInfoModal from '../../../../Components/PessoalInfoModal/PessoalInfoModal'
import { EventosContext } from '../../../../Providers/EventosContext/EventosContext'

const ListaVisitantesDentro = () => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { listaSaida, setListaSaida, setMetricas } = useContext(VisitantesContext)
    const { updateObsIframe } = useContext(EventosContext)
    const { activeCond } = useContext(CondominiosContext)
    const [pessoasCheck, setPessoasCheck] = useState([])
    const [open, setOpen] = useState(false)
    const [info, setInfo] = useState(null)

    const getListaVisitantesSaida = (msg) => {
        if (msg.data.status) {
            let dados = msg.data.listaSaida
            setListaSaida([...dados.visitantesAutorizados, ...dados.entrouDispositivo])

            setMetricas({
                visitantes: dados.totalMetricas['Visitantes (AppOne)'],
                prest: dados.totalMetricas['Prest. Serviço (AppOne)'],
                hospede: dados.totalMetricas['Hóspede (AppOne)']
            })
        } else {
            showNotify('warning', 'Erro ao listar visitantes')
        }
    }

    const buscaListaVisitantesSaida = () => {
        sendWs("listaVisitantesSaida", { filtros: { id_central: activeCond.id_central, filtro: '', id_entrada: '' } })
        addRoute('listaVisitantesSaida', getListaVisitantesSaida)
    }

    useEffect(() => {
        buscaListaVisitantesSaida()
    }, [])

    const handleCheckbox = (event) => {
        const pessoaCdAcesso = event.target.id
        let visitante = listaSaida.find((pessoa) => pessoa.CD_VISITANTE == pessoaCdAcesso)

        if (visitante) {
            if (event.target.checked) {
                setPessoasCheck((prev) => [...prev, {
                    id_historico: visitante.id ? visitante.id : '',
                    tipoDentro: visitante.tipoDentro,
                    cd_acesso: visitante.CD_VISITANTE,
                    tipo: visitante.tipo,
                    nome: visitante.nome
                }
                ])
            } else {
                setPessoasCheck((prevPessoas) => prevPessoas.filter((p) => p.cd_acesso != visitante.CD_VISITANTE))
            }
        } else {
            showNotify('error', 'Erro ao selecionar pessoa')
        }
    }

    const liberarSaidaVisitante = (id) => {
        const dados = {
            log: '| Saída autorizada',
            id_entrada: id,
            acao: 'saida',
            arrayDadosPessoas: pessoasCheck || '',
            id_central: activeCond.id_central
        }
        sendWs('autorizarSaidas', { filtros: dados })
        addRoute('autorizarSaidas', getLiberarSaida)
    }

    const atualizaLiberados = (dados) => {
        let cdAcesso = dados.dados.liberados.map((pessoa) => pessoa.cd_acesso || pessoa.CD_VISITANTE)
        let lista = listaSaida.filter((pessoa) => !cdAcesso.includes(pessoa.CD_VISITANTE || pessoa.cd_acesso))
        setListaSaida(lista)
    }

    const getLiberarSaida = (msg) => {
        let dados = msg.data
        if (dados.dados && dados.dados.status) {
            updateObsIframe(`Saída autorizada para visitante(s): ${dados.dados.liberados.map((pessoa) => pessoa.nome).join(', ')}`)
            setPessoasCheck([])
            showNotify("success", 'Pessoa(s) liberada(s)')
            if (dados.dados.liberados == undefined) {
                buscaListaVisitantesSaida()
            } else {
                atualizaLiberados(dados)
            }
        } else {
            showNotify("warning", "Erro ao liberar usuario")
        }
    }

    const abrirModal = (row) => {
        setOpen(true)
        setInfo(row)
    }

    const columns = [
        {
            name: 'Nome',
            cell: row => row.nome
                ? <div style={{ display: 'flex', cursor: 'pointer', alignItems: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    <input key={row.id} type="checkbox" id={row.CD_VISITANTE} name="nome" onChange={handleCheckbox} />
                    <label onClick={() => {
                        const rowChecked = document.getElementById(row.CD_VISITANTE)
                        rowChecked.checked = !rowChecked.checked
                        handleCheckbox({ target: { id: row.CD_VISITANTE, checked: rowChecked.checked } })
                    }
                    } style={{
                        fontSize: '12px',
                        fontWeight: 600,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        cursor: 'pointer'
                    }} htmlFor="nome">{row.nome}</label>
                </div>
                : "",
            style: {
                width: '20%',
                display: 'flex',
                alignItems: 'center'
            }
        },
        {
            name: `${activeCond.pais === 'es-CL' ? 'RUT' : 'CPF'}`,
            cell: row => row.cpf
                ? <div onClick={() => {
                    const rowChecked = document.getElementById(row.CD_VISITANTE)
                    rowChecked.checked = !rowChecked.checked
                    handleCheckbox({ target: { id: row.CD_VISITANTE, checked: rowChecked.checked } })
                }
                } style={PaiEllipsis}><p style={{ ...Ellipsis, fontSize: '12px', fontWeight: 600 }}>{row.cpf}</p></div>
                : <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer'
                }}
                onClick={
                    () => {
                        const rowChecked = document.getElementById(row.CD_VISITANTE)
                        rowChecked.checked = !rowChecked.checked
                        handleCheckbox({ target: { id: row.CD_VISITANTE, checked: rowChecked.checked } })
                    }
                }></div>,
            style: {
                width: '10%',
                display: 'flex',
                alignItems: 'center'
            }
        },
        {
            name: 'Imóvel',
            cell: row => row.imovel
                ? <div onClick={() => {
                    const rowChecked = document.getElementById(row.CD_VISITANTE)
                    rowChecked.checked = !rowChecked.checked
                    handleCheckbox({ target: { id: row.CD_VISITANTE, checked: rowChecked.checked } })
                }
                } style={PaiEllipsis}><p style={{ ...Ellipsis, fontSize: '12px', fontWeight: 600 }}>{row.imovel}</p></div>
                : <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer'
                }}
                onClick={
                    () => {
                        const rowChecked = document.getElementById(row.CD_VISITANTE)
                        rowChecked.checked = !rowChecked.checked
                        handleCheckbox({ target: { id: row.CD_VISITANTE, checked: rowChecked.checked } })
                    }
                }></div>,
            style: {
                width: '20%',
                display: 'flex',
                alignItems: 'center'
            }
        },
        {
            name: 'Placa',
            cell: row => row.placa
                ? <div onClick={() => {
                    const rowChecked = document.getElementById(row.CD_VISITANTE)
                    rowChecked.checked = !rowChecked.checked
                    handleCheckbox({ target: { id: row.CD_VISITANTE, checked: rowChecked.checked } })
                }
                } style={PaiEllipsis}><p style={{ ...Ellipsis, fontSize: '12px', fontWeight: 600 }}>{row.placa}</p></div>
                : <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer'
                }}
                onClick={
                    () => {
                        const rowChecked = document.getElementById(row.CD_VISITANTE)
                        rowChecked.checked = !rowChecked.checked
                        handleCheckbox({ target: { id: row.CD_VISITANTE, checked: rowChecked.checked } })
                    }
                }></div>,
            style: {
                width: '5%',
                display: 'flex',
                alignItems: 'center'
            }
        },
        {
            name: 'Tipo',
            cell: row => row.tipo
                ? <div onClick={() => {
                    const rowChecked = document.getElementById(row.CD_VISITANTE)
                    rowChecked.checked = !rowChecked.checked
                    handleCheckbox({ target: { id: row.CD_VISITANTE, checked: rowChecked.checked } })
                }
                } style={PaiEllipsis}><p style={{ ...Ellipsis, fontSize: '12px', fontWeight: 600 }}>{row.tipo}</p></div>
                : <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer'
                }}
                onClick={
                    () => {
                        const rowChecked = document.getElementById(row.CD_VISITANTE)
                        rowChecked.checked = !rowChecked.checked
                        handleCheckbox({ target: { id: row.CD_VISITANTE, checked: rowChecked.checked } })
                    }
                }></div>,
            style: {
                width: '10%',
                display: 'flex',
                alignItems: 'center'
            }
        },
        {
            name: 'Data Entrada',
            cell: row => row.data
                ? <div onClick={() => {
                    const rowChecked = document.getElementById(row.CD_VISITANTE)
                    rowChecked.checked = !rowChecked.checked
                    handleCheckbox({ target: { id: row.CD_VISITANTE, checked: rowChecked.checked } })
                }
                } style={PaiEllipsis}><p style={{ ...Ellipsis, fontSize: '12px', fontWeight: 600 }}>{row.data}</p></div>
                : <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer'
                }}
                onClick={
                    () => {
                        const rowChecked = document.getElementById(row.CD_VISITANTE)
                        rowChecked.checked = !rowChecked.checked
                        handleCheckbox({ target: { id: row.CD_VISITANTE, checked: rowChecked.checked } })
                    }
                }></div>,
            style: {
                width: '10%',
                display: 'flex',
                alignItems: 'center'
            }
        },
        {
            name: '',
            cell: row => row.nome
                ? <Grid sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                    <InfoSharpIcon sx={{
                        height: '95%',
                        cursor: 'pointer',
                        color: row.obs && row.obs != ''
                            ? 'red'
                            : 'black',
                        animation: row.obs && row.obs != '' ? `${blinkAnimation} 1s 3` : 'none'
                    }} onClick={ () => abrirModal(row) } />
                </Grid>
                : "",
            style: {
                width: '0.5%',
                display: 'flex',
                alignItems: 'center'
            }
        }
    ]

    return (
        <Grid sx={{ width: '80%', height: '100%' }}>
            <Grid component={'form'} sx={{
                width: '100%',
                height: '50%'
            }}>
                {
                    listaSaida && <FigmaTable
                        data={listaSaida}
                        columns={columns}
                    ></FigmaTable>
                }
            </Grid>

            <Grid sx={{ width: '100%', height: '40%', borderRight: '1px solid white', overflow: 'auto' }}>
                <Grid sx={{ width: '97%' }} >
                    <ListaEntradas callbackAbrirPorta={liberarSaidaVisitante} isDisabled={() => { return !(pessoasCheck && pessoasCheck.length > 0) }}></ListaEntradas>
                </Grid>
            </Grid>

            {
                open &&
                <PessoalInfoModal openInfoPessoa={open} setOpenInfoPessoa={setOpen} pessoa={info} facial={false}></PessoalInfoModal>
            }
        </Grid>

    )
}

export default ListaVisitantesDentro

const blinkAnimation = keyframes`
    0% {
        color: red;
    }
    33% {
        color: blue;
    }
    66% {
        color: red;
    }
    100% {
        color: red;
    }
`
